






















/* eslint-disable no-new */
import { version } from '@/../package.json';
import { companyHost } from '@/consts/companyHost';
import ReloadComponentMixin from '@/mixins/ReloadComponentMixinWithoutClassComponent';
import auth from '@/store/types/auth';
import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';
import Vue from 'vue';
import { FadeTransition } from 'vue2-transitions';
import { mapGetters, mapActions } from 'vuex';
import { getAuthPayload } from '@/util/HTTPCommpix';
import DashboardNavbar from './DashboardNavbar.vue';
import operationType from '@/store/types/operationType';
import paymentMethod from '@/store/types/paymentMethod';
import paymentMode from '@/store/types/paymentMode';
import paymentStatus from '@/store/types/paymentStatus';
import bankAccountType from '@/store/types/bankAccountType';
import payoutMethod from '@/store/types/payoutMethod';
import payoutPixType from '@/store/types/payoutPixType';
import credentialType from '@/store/types/credentialType';
import payoutStatus from '@/store/types/payoutStatus';

function hasElement(className: string) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className: string) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

export default Vue.extend({
  name: 'Dashboardlayout',
  components: {
    DashboardNavbar,
    FadeTransition,
  },
  mixins: [ReloadComponentMixin],
  provide() {
    return {
      initialDataLoaded: () => this.initialDataLoaded,
    };
  },
  data: () => ({
    logo: `${process.env.VUE_APP_SIDEBAR_LOGO}`,
    companyHost,
    version,
    isMobile: window.innerHeight < 768,
    toggable: true,
    initialDataLoaded: false,
  }),

  computed: {
    ...mapGetters({
      permissionServer: `authModule/${auth.getters.PERMISSIONS}`,
      optionsMenu: `authModule/${auth.getters.GET_MENU}`,
      nemiApiToken: `authModule/${auth.getters.GET_NEMI_API_TOKEN}`,
      currentUser: `authModule/${auth.getters.GET_AUTH_USER}`,
    }),
    marginLeft(): Record<string, string> {
      return {
        marginLeft: this.isMobile
          ? this.isMobile
            ? '0px'
            : '95px'
          : this.toggable
            ? '250px'
            : '95px',
      };
    },
    isCommpixTokenAvailable(): boolean {
      return !!this.nemiApiToken;
    },
  },

  mounted(): void {
    this.isMobileEvaluation();
    this.initScrollbar();
    this.registerResizing();
    // If the token is already available, load immediately
    if (this.isCommpixTokenAvailable && !this.initialDataLoaded) {
      this.loadInitialData();
    }
    // Otherwise, the watcher will handle loading when it becomes available
  },

  watch: {
    isCommpixTokenAvailable(newValue: boolean): void {
      if (newValue && !this.initialDataLoaded) {
        this.loadInitialData();
      }
    },
  },

  methods: {
    ...mapActions({
      operationTypesList: `operationTypeModule/${operationType.actions.OPERATION_TYPES_LIST}`,
      paymentMethodsList: `paymentMethodModule/${paymentMethod.actions.PAYMENT_METHODS_LIST}`,
      paymentModesList: `paymentModeModule/${paymentMode.actions.PAYMENT_MODES_LIST}`,
      paymentStatusList: `paymentStatusModule/${paymentStatus.actions.PAYMENT_STATUS_LIST}`,
      bankAccountTypesList: `bankAccountTypeModule/${bankAccountType.actions.BANK_ACCOUNT_TYPES_LIST}`,
      payoutMethodsList: `payoutMethodModule/${payoutMethod.actions.PAYOUT_METHODS_LIST}`,
      payoutPixTypesList: `payoutPixTypeModule/${payoutPixType.actions.PAYOUT_PIX_TYPES_LIST}`,
      credentialTypesList: `credentialTypeModule/${credentialType.actions.CREDENTIAL_TYPES_LIST}`,
      payoutStatusList: `payoutStatusModule/${payoutStatus.actions.PAYOUT_STATUS_LIST}`,
    }),

    isMobileEvaluation(): void {
      this.isMobile = window.innerWidth < 768;
    },

    registerResizing() {
      window.addEventListener('resize', this.updateScreenSize);
    },

    updateScreenSize(val: Event) {
      this.isMobile = (val.target as Window).innerWidth < 768;
    },

    onToggableChange(t: boolean): void {
      this.toggable = t;
    },

    initScrollbar(): void {
      const isWindows = navigator.platform.startsWith('Win');

      if (isWindows) {
        initScrollbar('sidenav');
      }
    },
    sidebarToggle(): void {
      this.toggable = !this.toggable;
    },

    async loadInitialData(): Promise<void> {
      if (this.initialDataLoaded) {
        return;
      }
      try {
        await this.getCommpixCredentials();
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error loading initial data:', error);
      }
      await Promise.all([
        this.paymentMethodsList(),
        this.operationTypesList(),
        this.paymentModesList(),
        this.paymentStatusList(),
        this.bankAccountTypesList(),
        this.payoutMethodsList(),
        this.payoutPixTypesList(),
        this.credentialTypesList(),
        this.payoutStatusList()
      ]);
      this.initialDataLoaded = true;
    },

    async getCommpixCredentials(): Promise<void> {
      const authPayload = getAuthPayload();

      const updatedAuthPayload = {
        company_id: authPayload.companyId,
        commerce_id: authPayload.commerceId,
        branch_id: authPayload.branchId,
        user: authPayload.username,
      };
      await Promise.all([
        this.$store.dispatch('authModule/GET_COMMPIX_CREDENTIALS', updatedAuthPayload).catch(err => {
          if (!(err && err.response && err.response.status === 404)) {
            throw err;
          }
        }),
        this.$store.dispatch('authModule/GET_MASSPAYMENT_CREDENTIALS', updatedAuthPayload).catch(err => {
          if (!(err && err.response && err.response.status === 404)) {
            throw err;
          }
        }),
        this.$store.dispatch('authModule/GET_MANTECA_CREDENTIALS', updatedAuthPayload).catch(err => {
          if (!(err && err.response && err.response.status === 404)) {
            throw err;
          }
        })
      ]);
    },
  },
  beforeDestroy(): void {
    window.removeEventListener('resize', this.updateScreenSize);
  },
});
